import * as d3 from 'd3';

export function drawShortFractionalGrillsOculus(
  svg,
  x,
  y,
  width,
  height,
  frameWidth = 10,
  lineColor = 'white',
  borderColor = 'black',
  borderWidth = 0.2,
  includeTop = true,
  includeBottom = false,
  grillThickness = 2,
  radiusX = width / 2,
  radiusY = height / 2,
  outerShape = 'Rect'
) {
  const glassX = x;
  const glassY = y;
  const glassWidth = width;
  const glassHeight = height;

  const grillHeight = glassHeight * 0.25; // 25% of height

  const leftX = glassX + glassWidth * 0.2;
  const rightX = glassX + glassWidth * 0.8;
  const topY = glassY;
  const bottomY = glassY + glassHeight - grillHeight;

  // ALWAYS clip grills to the inner glass ellipse (oculus is always a circle/oval)
  const clipId = `ellipseClip_${Math.random().toString(36).substring(2, 11)}`;
  const centerX = glassX + glassWidth / 2;
  const centerY = glassY + glassHeight / 2;

  svg.append('defs')
    .append('clipPath')
    .attr('id', clipId)
    .append('ellipse')
    .attr('cx', centerX)
    .attr('cy', centerY)
    .attr('rx', radiusX)
    .attr('ry', radiusY);

  const grillContainer = svg.append('g')
    .attr('clip-path', `url(#${clipId})`);

  if (includeTop) {
    // Left top grill
    grillContainer.append('rect')
      .attr('x', leftX - grillThickness / 2)
      .attr('y', topY)
      .attr('width', grillThickness)
      .attr('height', grillHeight)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);

    // Right top grill
    grillContainer.append('rect')
      .attr('x', rightX - grillThickness / 2)
      .attr('y', topY)
      .attr('width', grillThickness)
      .attr('height', grillHeight)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);
  }

  if (includeBottom) {
    // Left bottom grill
    grillContainer.append('rect')
      .attr('x', leftX - grillThickness / 2)
      .attr('y', bottomY)
      .attr('width', grillThickness)
      .attr('height', grillHeight)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);

    // Right bottom grill
    grillContainer.append('rect')
      .attr('x', rightX - grillThickness / 2)
      .attr('y', bottomY)
      .attr('width', grillThickness)
      .attr('height', grillHeight)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);
  }
}




